<template>
  <div class="container-checkbox">
    <div
      class="checkbox d-flex align-items-center"
      :class="{ blocked: item.disabled }"
      v-for="(item, index) in values"
      :key="index"
      @click="toggle(index)"
    >
      <i
        :class="{
          'icon-square-o text-secondary': !item.value,
          'icon-check-square text-primary': item.value
        }"
      ></i>
      <span>{{ item.label }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    values: {
      type: Array,
      default: () => {
        [];
      }
    }
  },
  methods: {
    toggle(val) {
      if (!this.values[val].disabled) {
        this.values[val].value = !this.values[val].value;
        this.$emit("change");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.container-checkbox {
  .checkbox {
    cursor: pointer;
    padding-top: 8px;
    i {
      font-size: 24px;
      margin-right: 8px;
    }

    span {
      color: #595463;
    }
  }

  .blocked {
    opacity: 0.5;
  }
}
</style>
